import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import GlobalSnackbar from "./components/GlobalSnackbar";
import { AuthProvider } from "./contexts/AuthContext";
import { RevenueCatProvider } from "./contexts/RevenueCatContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import Home from "./screens/Home";
import Login from "./screens/Login";
import RecentFits from "./screens/RecentFits";
import Register from "./screens/Register";
import Subscription from "./screens/Subscription";
import Wardrobe from "./screens/Wardrobe";
import { CustomThemeProvider } from "./theme";

function App() {
  return (
    <CustomThemeProvider>
      <AuthProvider>
        <RevenueCatProvider>
          <SnackbarProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/recent-fits"
                  element={
                    <ProtectedRoute>
                      <RecentFits />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/subscription"
                  element={
                    <ProtectedRoute>
                      <Subscription />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/wardrobe"
                  element={
                    <ProtectedRoute>
                      <Wardrobe />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <GlobalSnackbar />
            </Router>
          </SnackbarProvider>
        </RevenueCatProvider>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;
